import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Row, Col } from "react-bootstrap";
import PieChartComponent from "./PieChartComponent/pie-chart-component";
import "./Styles/dashboard-plan-info.scss";
const DashboardPlanInfo = (props) => {
  let navigate = useNavigate();

  const { upgradePlan } = props;

  const handleGetMoreSeats = () => {
    navigate("/account", { replace: false });
  };
  return (
    <div className="dashboard-plan-info">
      <Row>
        <PieChartComponent {...props} />
      </Row>
      <Row className="chart-desc">
        <Col className="col-md-6">
          <div className="seats-data">
            <div className="purple-circle"></div>
            <h6>Remaining Users</h6>
          </div>
        </Col>
        <Col className="col-md-6">
          <div className="seats-data">
            <div className="yellow-circle"></div>
            <h6>Active Users</h6>
          </div>
        </Col>
      </Row>
      {!upgradePlan && (
        <Row className="upgrade-block">
          <Col className="col-md-5">
            <div className="current-plan-title">Current Plan</div>
            <div className="current-plan">
              {props?.planName || "Loading..."}
            </div>
          </Col>
          <Col className="col-md-7">
            <Button className="big-purple-btn" onClick={handleGetMoreSeats}>
              Get more seats
            </Button>
          </Col>
        </Row>
      )}

      {upgradePlan && (
        <div>
          <Row className="justify-content-md-center">
            <Col md="auto">
              <div className="current-plan-title">Current Plan</div>
            </Col>
          </Row>
          <Row className="justify-content-md-center">
            <Col md="auto">
              <div className="current-plan">
                {props?.planName || "Loading..."}
              </div>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};
export default DashboardPlanInfo;
